<template>
    <div class="verify-code" @click="generate">
        <div class="get-code" v-show="!waiting">获取验证码</div>
        <div class="wait-code" v-show="waiting">{{waiting}}秒</div>
    </div>
</template>

<script type="text/babel">

    import apis from '@/store/apis'

export default {
    name: 'sms-code',
    props: {
        getCode:{
            type: Function,
            require: true
        },
        checkPhone: {
            type: Function,
            require: false
        },
        step: null,
        newPhone: null,
    },
    data () {
        return {
            waiting: 0
        }
    },
    methods: {
        get() {
            this.getCode().then((res) => {

                if (!res.data.result) {
                    this.$message({
                        type: 'error',
                        message: res.data.message
                    })
                } else {
                    this.waiting = 30;
                    let timer = window.setInterval(() => {
                        if (!--this.waiting) {
                            window.clearInterval(timer)
                        }
                    }, 1000)
                }
            })
        },
        generate(){

            if(this.waiting){
                return
            }

            if (!this.checkPhone()) {
                this.$message({type: 'error', message: '手机号码不正确'})
                return
            }

            // if(this.step > 1) {

            //     apis.checkPhone(this.newPhone).then((res) =>{
            //         if (res.data.result) {
            //             this.get();
            //         }
            //     }, e => {
            //         callback()
            //     })

            //     return
            // }

            this.get();

        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .verify-code{
        font-size: 16px;
        text-align: center;
        cursor: pointer;
        margin-bottom: 5px;
        width: 100px;
        height: 30px;
        color: rgb(102, 204, 102);
    }

</style>



// WEBPACK FOOTER //
// src/components/SmsCode.vue